// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"536":"a68f7225","734":"8d9f261c"}[chunkId] + ".chunk.css";
};